import { ThemeProvider } from '@emotion/react';
import EditOutlined from '@mui/icons-material/EditOutlined';
import Typography from '@mui/material/Typography';
import ProfileOtherPostCard from 'components/molecules/Card/ProfileOtherPostCard';
import ProfileOwnPostCard from 'components/molecules/Card/ProfileOwnPostCard';
import {
  TitleText,
  EditLayer,
  EditText,
  ContentGrid,
  colortheme,
  Body,
} from './Styles';
import * as React from 'react';

const FeedBody = () => {
  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <Body
          container
          style={{
            maxWidth: '1300px',
            marginTop: '80px',
            background: 'rgba(255,255,255,0.01)',
            borderRadius: '20px',
            paddingTop: '40px',
          }}
        >
          <ContentGrid item xs={12}>
            <TitleText>👋 Welcome to my Backstage! </TitleText>
            <EditLayer>
              <EditOutlined sx={{ fontSize: '20px' }} />
              <EditText>Edit</EditText>
            </EditLayer>
          </ContentGrid>
          <ContentGrid item xs={12}>
            <Typography
              component={'span'}
              sx={{ color: '#c1c1c1', fillRule: 'evenodd' }}
            >
              <span>
                This is where you post your description about what you offer in
                your backstage subscription!
              </span>
              <span style={{ color: '#ddb930' }}>&nbsp; See more</span>
            </Typography>
          </ContentGrid>
          <ProfileOwnPostCard backstagePosts={[]} />
          <ProfileOtherPostCard isImg={undefined} isChart={undefined} />
          <ProfileOtherPostCard isImg={true} isChart={undefined} />
          <ProfileOtherPostCard isChart={true} isImg={undefined} />
        </Body>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default FeedBody;
